// Vendors
import {
  CountriesLocaleEnumeration,
  StorageLocalEnumeration,
} from '@gruposantander/opbpay-ui-core-models';
import { MessageFormatElement } from 'react-intl';
// Constants
import {
  ALLOWED_LANGUAGES,
  LOCALE_QUERY_PARAM,
} from './constants/internationalization.hook.utils.constants';
// Types
import { InternationalizationHookUtilsType } from './types/internationalization.hook.utils.type';

const getLocaleFromQueryParam = (): string => {
  const locale = new URLSearchParams(window.location.search).get(LOCALE_QUERY_PARAM) || '';

  return locale ? locale : '';
};

const getUserLanguage = ({ languagePreference }: InternationalizationHookUtilsType): string =>
  languagePreference &&
  ALLOWED_LANGUAGES?.includes(languagePreference as CountriesLocaleEnumeration)
    ? languagePreference
    : CountriesLocaleEnumeration.SPAIN;

const getTranslationsFromStorage = ():
  | { value: string[] }
  | { [key: string]: never }
  | Record<string, MessageFormatElement[]> =>
  JSON.parse(localStorage.getItem(StorageLocalEnumeration.TRANSLATIONS) || '{}');

export { getLocaleFromQueryParam, getTranslationsFromStorage, getUserLanguage };
